import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../PopupCommonStyle.css';
import styles from './Style.module.css';
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnClose } from '../../Buttons/BtnClose/BtnClose';

export const AvailabilityPopup = ({ message, onChooseService, isLoading = false, error }) => {
  const dialogRef = useRef(null);
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    const previousFocus = document.activeElement;
    dialogRef.current?.querySelector('button:not(:disabled)')?.focus();
    return () => {
      if (previousFocus?.isConnected && previousFocus.getAttribute('aria-disabled') !== 'true') {
        previousFocus.focus();
      }
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
    }
    if (event.key === 'Tab') {
      const buttons = dialogRef.current.querySelectorAll('button:not(:disabled)');
      if (!buttons.length) {
        event.preventDefault();
        return;
      }
      const first = buttons[0];
      const last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  return createPortal(
    <>
    <div className={styles.backdrop} data-availability-backdrop aria-hidden="true" />
    <div ref={dialogRef} className="popup show" role="dialog" aria-modal="true"
      aria-labelledby={titleId} aria-describedby={descriptionId} onKeyDown={handleKeyDown}>
      <BtnClose title="Close" customClass="closeBtn" role="button" handleClick={onChooseService}/>
      <div className="popup-header">
        <h2 id={titleId} className="title">Unable to Continue</h2>
        <p id={descriptionId} className="titleSub">{message}</p>
        {error && <p role="alert">{error}</p>}
      </div>
      <div className="popup-footer">
        <BtnPrimary label={isLoading ? 'Loading services…' : 'Choose Another Service'}
          disabled={isLoading} nativeDisabled handleClick={onChooseService} customClass="w-100 no-icon" />
      </div>
    </div>
    </>,
    document.body
  );
};
